import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import "./SupportWidget.css";

export default function SupportWidget({ open, onClose, onSubmit }) {
  useEffect(() => {
    const onEsc = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [onClose]);

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData(e.currentTarget);
    const payload = {
      subject: form.get("subject")?.trim(),
      message: form.get("message")?.trim(),
    };
    onSubmit?.(payload);
  };

  return (
    <div className="sw-overlay" aria-modal="true" role="dialog">
      <div className="sw-panel" role="document">
        <button className="sw-close" aria-label="Close" onClick={onClose}>
          <FaTimes />
        </button>

        <header className="sw-header">
          <div className="sw-avatars">
            <div className="sw-avatar" />
            <div className="sw-avatar sw-avatar-b" />
          </div>
          <div>
            <div className="sw-title">How can we help?</div>
            <div className="sw-sub">We usually respond in a few hours</div>
          </div>
        </header>

        <form className="sw-form" onSubmit={handleSubmit}>
          <label className="sw-label">Subject</label>
          <input name="subject" className="sw-input" placeholder="Subject" required />

          <label className="sw-label">How can we help?</label>
          <textarea
            name="message"
            className="sw-textarea"
            placeholder="Describe your issue or question…"
            rows={5}
            required
          />

          <div className="sw-actions">
            <button type="submit" className="sw-send">Send a message</button>
          </div>
        </form>
      </div>
    </div>
  );
}
